import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "uploadSection",
    "urlSection",
    "fileInput",
    "urlInput",
    "altInput",
    "preview",
    "previewImage",
    "removeSection",
    "removeInput",
    "sourceUpload",
    "sourceUrl"
  ]

  connect() {
    this.detectCurrentSource()
  }

  // Detect whether the event already has an image (upload or URL) on edit
  detectCurrentSource() {
    const urlValue = this.hasUrlInputTarget && this.urlInputTarget.value
    const hasExistingImage = this.hasPreviewTarget && this.previewTarget.dataset.hasImage === "true"

    if (urlValue) {
      this.showUrl()
      if (this.hasSourceUrlTarget) this.sourceUrlTarget.checked = true
    } else if (hasExistingImage) {
      this.showUpload()
      if (this.hasSourceUploadTarget) this.sourceUploadTarget.checked = true
    } else {
      this.showUpload()
      if (this.hasSourceUploadTarget) this.sourceUploadTarget.checked = true
    }
  }

  // Switch to file upload mode
  selectUpload() {
    this.showUpload()
    if (this.hasUrlInputTarget) this.urlInputTarget.value = ""
  }

  // Switch to URL mode
  selectUrl() {
    this.showUrl()
    if (this.hasFileInputTarget) this.fileInputTarget.value = ""
    this.hidePreviewImage()
  }

  showUpload() {
    if (this.hasUploadSectionTarget) this.uploadSectionTarget.classList.remove("hidden")
    if (this.hasUrlSectionTarget) this.urlSectionTarget.classList.add("hidden")
  }

  showUrl() {
    if (this.hasUploadSectionTarget) this.uploadSectionTarget.classList.add("hidden")
    if (this.hasUrlSectionTarget) this.urlSectionTarget.classList.remove("hidden")
  }

  // Preview selected file
  previewFile() {
    const file = this.fileInputTarget.files[0]
    if (!file) return

    const reader = new FileReader()
    reader.onload = (e) => {
      if (this.hasPreviewImageTarget) {
        this.previewImageTarget.src = e.target.result
        this.previewImageTarget.classList.remove("hidden")
      }
    }
    reader.readAsDataURL(file)

    if (this.hasRemoveSectionTarget) this.removeSectionTarget.classList.remove("hidden")
  }

  // Remove image
  removeImage() {
    if (this.hasRemoveInputTarget) this.removeInputTarget.value = "1"
    if (this.hasFileInputTarget) this.fileInputTarget.value = ""
    if (this.hasUrlInputTarget) this.urlInputTarget.value = ""
    this.hidePreviewImage()
    if (this.hasRemoveSectionTarget) this.removeSectionTarget.classList.add("hidden")

    // Submit form or let the hidden field handle it
  }

  hidePreviewImage() {
    if (this.hasPreviewImageTarget) {
      this.previewImageTarget.src = ""
      this.previewImageTarget.classList.add("hidden")
    }
  }
}
